import React, { RefObject, useEffect, useRef } from 'react';
import classNames from 'classnames';
import style from 'assets/jss/material-dashboard-pro-react/views/services/FixedBusinessBroadband/orderStyle';
import { makeStyles } from '@material-ui/core';
import { BodyMBold, DisplayM } from 'components/Typography/Typography';
import { dynamicTranslate } from 'components/Translation';
import ConditionalRender from 'components/ConditionalRender/ConditionalRender';
import VatClause from 'components/VatClause/VatClause';
import PlanDetailSummary from './common/PlanDetailSummary';
import Button from 'components/CustomButtons/Button';
import CustomCircularProgress from 'components/CustomCircularProgress/CustomCircularProgress';
import { useSelector } from 'react-redux';
import { getCommonLabels, getFiberProLabels } from 'redux/modules/dynamicLabels/selectors';

// @ts-ignore
const useStyles = makeStyles(style);

interface IOrderProps {
	termsAndConditions?: React.ReactElement;
	loading: boolean;
	lines: types.services.fixed.fixedBusinessBroadband.ILine[];
	orderSummary: types.services.fixed.fixedBusinessBroadband.OrderSummary;
	handleRemoveItem: (ind: number) => void;
}

const OrderSummaryTab = (props: IOrderProps) => {
	const classes = useStyles();
	const fiberProLabels = useSelector(getFiberProLabels);
	const commonLabels = useSelector(getCommonLabels);
	// this component get focussed - for accessibility 
	const ref: RefObject<HTMLDivElement> = useRef(null);
	useEffect(() => {
		if (ref.current) ref.current.focus();
	}, []);
	return (
		<ConditionalRender
			show={props.loading}
			onTrue={() => (
				<div>
					<CustomCircularProgress text={commonLabels.loading} loading transparent />
				</div>
			)}
			onFalse={() => (
				<div ref={ref}>
					{props.orderSummary.lineDetails.map((line) => {
						return (
							<div key={line.adslUserName}>
								<div className={classes.userNameWrapper}>
									<BodyMBold customClassName={classes.userNameLabel}>{line.adslUserName}</BodyMBold>
									<ConditionalRender
										show={props.orderSummary.lineDetails.length > 1}
										onTrue={() => (
											<Button
												color="tertiary-danger"
												onClick={() => {
													const index = props.lines.findIndex((singleLine) => {
														return singleLine.name === line.adslUserName;
													});
													props.handleRemoveItem(index);
												}}
											>
												{fiberProLabels.deleteLine}
											</Button>
										)}
									/>
								</div>
								<PlanDetailSummary line={line} />
							</div>
						);
					})}
					<div className={classes.summaryContainer}>
						<div className={classes.summary}>
							<div className={classNames(classes.flex1, classes.alignCenter)}>
								<DisplayM color="primary-light" disableMargin>
									{fiberProLabels.summaryTabName}
								</DisplayM>
							</div>
							<div className={classNames(classes.flex1, classes.alignRight)}>
								<DisplayM disableMargin color="primary-light">
									{dynamicTranslate(commonLabels.price, props.orderSummary.summary)}
								</DisplayM>
							</div>
						</div>
					</div>
					<div className={classes.vat}>
						<VatClause />
					</div>
					<div className={classes.tc}>
						<ConditionalRender show={!!props.termsAndConditions} onTrue={() => props.termsAndConditions} />
					</div>
				</div>
			)}
		/>
	);
};

export default OrderSummaryTab;
